import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <LandingPage data-id="element-1" />
      <PurchasePopup data-id="element-2" />
    </>;
}